const shape = {
  borderRadius: 6,
};

export default shape;
